import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import departmentSvg from '../../../assets/images/svg/department.svg'
import { numberWithCommas } from "../../../helpers/globalHelper"
import toastr from "toastr";

import DeleteModal from '../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useOrgFindAllQuery, useDepartmentCreateMutation, useDepartmentFindAllQuery, useDepartmentUpdateMutation, useDepartmentDeleteMutation } from '../../../store';

const Detail = () => {
  const [isLoading, setLoading] = useState(true);
  const [customQuery, setCustomQuery] = useState<any>();


  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [departmentOne, setDepartmentOne] = useState<any>(null)
  const [departmentList, setDepartmentList] = useState<any>();
  const [orgList, setOrgList] = useState<any>();
  const [departmentCount, setDepartmentCount] = useState<any>();

  const {
    data: departmentData,
    error: positionError,
    isFetching: isPositionFetching,
  } = useDepartmentFindAllQuery();

  const {
    data: orgData,
    error: orgError,
    isFetching: isOrgFetching,
  } = useOrgFindAllQuery();

  const [departmentCreate, departmentCreateResult] = useDepartmentCreateMutation(customQuery);
  const [departmentUpdate, departmentUpdateResult] = useDepartmentUpdateMutation();
  const [departmentDelete, departmentDeleteResult] = useDepartmentDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    setDepartmentList(departmentData?.data)
    setOrgList(orgData?.data)
    setLoading(false)
    setDepartmentCount(departmentList?.length)

    setCustomPagination(departmentData?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [orgList, departmentData, customPageSize, customPageLength, customPagination])

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      department_name: departmentOne?.department_name,
      department_display: departmentOne?.department_display,
      department_value: departmentOne?.department_value,
      organization_id: departmentOne?.organization_id,
    },
    validationSchema: Yup.object({
      department_name: Yup.string().required("Утга оруулна уу !"),
      department_display: Yup.string().required("Утга оруулна уу !"),
      department_value: Yup.string().required("Утга оруулна уу !"),
      organization_id: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updateDepartmentList = {
          id: departmentOne ? departmentOne.department_id : 0,
          department_name: values.department_name,
          department_display: values.department_display,
          department_value: values.department_value,
          organization_id: values.organization_id,
        };
        departmentUpdate(updateDepartmentList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Амжилтгүй!", "Амжилтгүй");
          })
      } else {
        const newDepartmemtList = {
          department_name: values["department_name"],
          department_display: values["department_display"],
          department_value: values["department_value"],
          organization_id: values["organization_id"],
        };
        departmentCreate(newDepartmemtList)
          .unwrap()
          .then((response) => {
            toastr.success("Мэдээлэл амжилттай үслээ!", "Амжилттай");
          })
          .catch((error) => {
            toastr.error("Амжилтгүй!", "Амжилтгүй");
          })
      }
      validation.resetForm();
      toggle();
    },
  });




  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setDepartmentOne(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempDepartment = arg;

    setDepartmentOne({
      department_id: tempDepartment.department_id,
      department_name: tempDepartment.department_name,
      department_display: tempDepartment.department_display,
      department_value: tempDepartment.department_value,
      organization_id: tempDepartment.organization_id
    });

    setIsEdit(true);
    toggle();
  }, [toggle]);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (selectRowData) => {
    setDepartmentOne(selectRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (departmentOne) {
      departmentDelete(departmentOne?.department_id)
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setDepartmentOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "department_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.department_id}</Link>
        }
      },
      {
        header: "Хэлтэс нэр",
        accessorKey: "department_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Хэлтэс нэр 2",
        accessorKey: "department_display",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Хэлтэс утга',
        accessorKey: "department_value",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Харьяа байгууллага',
        accessorKey: "organization_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const positionData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(positionData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const selectRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(selectRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Soft delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },

    ],
    [handleJobClick]
  );




  return (
    <React.Fragment>
      <DeleteModal
        deleteName={departmentOne?.department_name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={departmentSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(departmentCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={departmentList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Албан тушаал засах" : "Албан тушаал нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label>Хэлтэс нэр </Label>
                  <Input
                    name="department_name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.department_name || ""}
                    invalid={
                      validation.touched.department_name && validation.errors.department_name ? true : false
                    }
                  />
                  {validation.touched.department_name && validation.errors.department_name ? (
                    <FormFeedback type="invalid">{validation.errors.department_name}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Хэлтэс нэр 2</Label>
                  <Input
                    name="department_display"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.department_display || ""}
                    invalid={
                      validation.touched.department_display && validation.errors.department_display ? true : false
                    }
                  />
                  {validation.touched.department_display && validation.errors.department_display ? (
                    <FormFeedback type="invalid">{validation.errors.department_display}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Хэлтэс утга</Label>
                  <Input
                    name="department_value"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.department_value || ""}
                    invalid={
                      validation.touched.department_value && validation.errors.department_value ? true : false
                    }
                  />
                  {validation.touched.department_value && validation.errors.department_value ? (
                    <FormFeedback type="invalid">{validation.errors.department_value}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Харьяа байгууллага</Label>
                  <Input
                    name="organization_id"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.organization_id || ""}
                    invalid={
                      validation.touched.organization_id && validation.errors.organization_id ? true : false
                    }
                  >
                    <option value="" disabled> Сонгох </option>
                    {orgList?.map((org) => (
                      <option key={org.organization_id} value={org.organization_id}>
                        {org.name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.organization_id && validation.errors.organization_id ? (
                    <FormFeedback type="invalid">{validation.errors.organization_id}</FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > {!!isEdit ? "Засварлах" : "Хадгалах"}</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;